import "../../stylesheets2025/registration.css";
import ScrollToTop from "../../components2026/ScrollToTop";

const indianFees = [
    {
        category: "Indian Author (Industry)",
        earlyIeee: "₹8,850",
        earlyNon: "₹10,620",
        stdIeee: "₹10,620",
        stdNon: "₹12,390",
    },
    {
        category: "Indian Author (Academia)",
        earlyIeee: "₹5,900",
        earlyNon: "₹7,080",
        stdIeee: "₹7,080",
        stdNon: "₹8,260",
    },
    {
        category: "Indian Professional Attendee",
        earlyIeee: "₹4,130",
        earlyNon: "₹4,720",
        stdIeee: "₹4,720",
        stdNon: "₹5,310",
    },
    {
        category: "Indian Student Attendee",
        earlyIeee: "₹1,000",
        earlyNon: "₹1,250",
        stdIeee: "₹1,250",
        stdNon: "₹1,500",
    },
];

const foreignFees = [
    {
        category: "Foreign Author (Academia / Industry)",
        earlyIeee: "$210.00",
        earlyNon: "$240.00",
        stdIeee: "$240.00",
        stdNon: "$270.00",
    },
    {
        category: "Foreign Student Author",
        earlyIeee: "$120.00",
        earlyNon: "$135.00",
        stdIeee: "$135.00",
        stdNon: "$150.00",
    },
    {
        category: "Foreign Professional Attendee (Non-Author)",
        earlyIeee: "$150.00",
        earlyNon: "$180.00",
        stdIeee: "$180.00",
        stdNon: "$210.00",
    },
];

const guidelines = [
    {
        text: "One full author registration (Indian or Foreign) is required for a paper to be included in the conference programme and IEEE proceedings.",
    },
    { text: "One full author registration covers up to 2 papers." },
    {
        text: "Additional authors who wish to attend must register separately as attendees.",
    },
    {
        text: "Student registration does not include IEEE Xplore paper publication.",
    },
    {
        text: "Fees include 18% GST. Payment gateway charges are extra.",
    },

    { text: "Registration fees are non-refundable." },
    {
        text: "Final papers may run up to 8 pages; pages beyond 6 incur the additional page charges noted in each fee table.",
    },
    {
        lead: "What full author and attendee registration includes",
        text: "Access to keynote sessions, technical sessions, the conference registration kit, lunch, high tea, and the gala dinner.",
        span: true,
    },
];

const FeeTable = ({ rows }) => (
    <>
        {/* Table — shown on wider screens */}
        <div className="fee-table-wrap">
            <table className="fee-table">
                <thead>
                    <tr>
                        <th className="cat-col" rowSpan={2}>
                            Participant Category
                        </th>
                        <th className="grp grp-early" colSpan={2}>
                            Early Bird
                        </th>
                        <th className="grp" colSpan={2}>
                            Standard
                        </th>
                    </tr>
                    <tr>
                        <th className="sub early">IEEE Member</th>
                        <th className="sub early">Non-IEEE</th>
                        <th className="sub">IEEE Member</th>
                        <th className="sub">Non-IEEE</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.category}>
                            <td className="cat">{row.category}</td>
                            <td className="early">{row.earlyIeee}</td>
                            <td className="early">{row.earlyNon}</td>
                            <td>{row.stdIeee}</td>
                            <td>{row.stdNon}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

        {/* Cards — shown on narrow screens */}
        <div className="fee-cards">
            {rows.map((row) => (
                <div className="fee-card" key={row.category}>
                    <h4 className="fee-card-title">{row.category}</h4>
                    <div className="fee-card-grid">
                        <div className="fee-cell early">
                            <span className="fee-tier">Early Bird · IEEE</span>
                            <span className="fee-amt">{row.earlyIeee}</span>
                        </div>
                        <div className="fee-cell early">
                            <span className="fee-tier">Early Bird · Non-IEEE</span>
                            <span className="fee-amt">{row.earlyNon}</span>
                        </div>
                        <div className="fee-cell">
                            <span className="fee-tier">Standard · IEEE</span>
                            <span className="fee-amt">{row.stdIeee}</span>
                        </div>
                        <div className="fee-cell">
                            <span className="fee-tier">Standard · Non-IEEE</span>
                            <span className="fee-amt">{row.stdNon}</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </>
);

const Registration = () => {
    return (
        <div className="containAll registration-page flex flex-col">
            <ScrollToTop />



            <section className="reg-shell">
                <div className="status-banner" role="status">
                    <span className="dot" aria-hidden="true" />
                    <div>
                        <h2>Registration Now Open</h2>
                        <p>
                            <strong>Early Bird Deadline:</strong> 7 November 2026
                        </p>
                        <p>
                            <strong>Registration Closes:</strong> 21 November 2026
                        </p>
                    </div>
                </div>


                <div className="section-intro">
                    <h3>Participant Registration</h3>
                    <p>
                        Choose your registration category based on your participant type and membership status.
                        Early bird rates are available for registrations completed by the early bird deadline.
                    </p>
                  
                </div>


                <div className="fee-block">
                    <div className="fee-head">
                        <h3 className="fee-title">
                            Indian National Registration Fees
                        </h3>
                        <span className="fee-currency">Amounts in INR (₹)</span>
                    </div>
                    <FeeTable rows={indianFees} />
                    <p className="per-page">
                        <strong>Additional page cost:</strong> ₹1,000 per page
                    </p>
                </div>

                <div className="fee-block">
                    <div className="fee-head">
                        <h3 className="fee-title">
                            Foreign National Registration Fees
                        </h3>
                        <span className="fee-currency">Amounts in USD ($)</span>
                    </div>
                    <FeeTable rows={foreignFees} />
                    <p className="per-page">
                        <strong>Additional page cost:</strong> $25 per page
                    </p>
                </div>

                <div className="guidelines">

                    <p className="guidelines-subtitle">
                        Please read the following guidelines carefully before
                        proceeding with your registration.
                    </p>

                    <ul className="guidelines-list">
                        {guidelines.map((item, i) => (
                            <li key={i} className={item.span ? "span-2" : ""}>
                                {item.lead && <strong>{item.lead}</strong>}
                                {item.text}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </div>
    );
};

export default Registration;